import axios from "axios";
const jsonConfig = require("../../Config.json");

const resetPasswordVerifyResponse = async (payload) => {
  let allResponse = {};
  try {
    const resetpasswordverifyData = await axios.post(
      jsonConfig.apiUrl + "resetpasswordverify",
      payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = resetpasswordverifyData;

    return Promise.resolve(allResponse);
  } catch (error) {
    console.log("errrrrr", error);
    return Promise.reject(error);
  }
};

export default resetPasswordVerifyResponse;
